import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = ({
  newAmbassadorStyle,
  isTravelResultsPage,
}: { newAmbassadorStyle?: boolean; isTravelResultsPage?: boolean } = {}) =>
  makeStyles(({ custom, breakpoints }: Theme) => ({
    root: {
      flexGrow: 1,
      backgroundColor: custom.grey[8],
      top: 0,
    },
    content: {
      paddingBottom: 80,
      paddingLeft: 20,
      paddingRight: 20,
      maxWidth: custom.pageWidth,
      margin: '0 auto',
      width: '100%',
      ...(!isTravelResultsPage && {
        display: 'flex',
        justifyContent: 'center',
      }),
    },
    mainContent: {
      display: 'flex',
      flexDirection: 'column',
      flex: 3,
      ...(newAmbassadorStyle
        ? {
            paddingTop: 10,
          }
        : {
            paddingTop: 20,
            [breakpoints.up(960)]: {
              paddingTop: 40,
            },
          }),
    },
    densePaddingTop: {
      paddingTop: '4px !important',
    },
    sidebar: {
      marginLeft: 60,
      width: 335,
    },
    [breakpoints.down(newAmbassadorStyle ? 1024 : 769)]: {
      sidebar: {
        display: 'none',
      },
    },
  }));
